import { useIsAnalyticsModuleEnabled } from "src/hooks/useIsAnalyticsModuleEnabled";
import { useIsCaseManagementEnabled } from "src/hooks/useIsCaseManagementEnabled";

type CaseAnalyticsAccess = {
  canAccess: boolean;
};

export const useCaseAnalyticsAccess = (): CaseAnalyticsAccess => {
  const { isEnabled: isAnalyticsModuleEnabled } = useIsAnalyticsModuleEnabled();
  const { isEnabled: isCaseManagementEnabled } = useIsCaseManagementEnabled();

  const canAccess = isAnalyticsModuleEnabled && isCaseManagementEnabled;

  return { canAccess };
};
